import { environment } from "../../environments/environment";


export const urlApi = `${environment.apiUrl}`;
export const urlErpApi = `${environment.apiErpUrl}`
